import React, { useState, useEffect } from 'react';
import { projectFirestore } from '../../firebase/config';

const DEFAULTS = {
    description: 'معرض التصوير لكلية التربية النوعية',
    emails: ['info-lighttale2022@gmail.com', 'gallery.lighttale2022@gmail.com'],
    socialLinks: {
        twitter: 'http://twitter.com/AliShakrany',
        facebook: 'http://fb.com/lighttale2022',
        whatsapp: 'https://api.whatsapp.com/send/?phone=201555090521&text&app_absent=0',
    },
};

const FooterEditor = () => {
    const [data, setData] = useState(DEFAULTS);
    const [emailInput, setEmailInput] = useState('');
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        const unsub = projectFirestore.collection('settings').doc('footer')
            .onSnapshot((doc) => {
                if (doc.exists) {
                    const d = doc.data();
                    setData({
                        description: d.description || DEFAULTS.description,
                        emails: d.emails || DEFAULTS.emails,
                        socialLinks: { ...DEFAULTS.socialLinks, ...(d.socialLinks || {}) },
                    });
                }
            });
        return () => unsub();
    }, []);

    const handleSave = async () => {
        setSaving(true);
        await projectFirestore.collection('settings').doc('footer').set(data, { merge: true });
        setSaving(false);
        alert('تم حفظ إعدادات الفوتر ✓');
    };

    const handleAddEmail = () => {
        const email = emailInput.trim();
        if (!email || data.emails.includes(email)) return;
        setData(prev => ({ ...prev, emails: [...prev.emails, email] }));
        setEmailInput('');
    };

    const handleRemoveEmail = (index) => {
        setData(prev => ({ ...prev, emails: prev.emails.filter((_, i) => i !== index) }));
    };

    return (
        <div className="container my-4">
            <h4 className="text-center mb-4">تعديل الفوتر والمعلومات</h4>

            {/* الوصف */}
            <div className="card shadow-sm mb-4">
                <div className="card-body">
                    <h5 className="card-title mb-3">وصف الموقع في الفوتر</h5>
                    <textarea className="form-control" rows={3} value={data.description}
                        onChange={e => setData(prev => ({ ...prev, description: e.target.value }))} />
                </div>
            </div>

            {/* الإيميلات */}
            <div className="card shadow-sm mb-4">
                <div className="card-body">
                    <h5 className="card-title mb-3">عناوين البريد الإلكتروني</h5>
                    {data.emails.map((email, i) => (
                        <div key={i} className="d-flex align-items-center gap-2 mb-2">
                            <span className="flex-grow-1 text-start" dir="ltr">{email}</span>
                            <button className="btn btn-outline-danger btn-sm" onClick={() => handleRemoveEmail(i)}>
                                <i className="fas fa-times"></i>
                            </button>
                        </div>
                    ))}
                    <div className="input-group mt-2">
                        <input type="email" className="form-control" placeholder="إضافة بريد جديد" dir="ltr"
                            value={emailInput} onChange={e => setEmailInput(e.target.value)}
                            onKeyDown={e => e.key === 'Enter' && handleAddEmail()} />
                        <button className="btn btn-outline-primary" onClick={handleAddEmail}>إضافة</button>
                    </div>
                </div>
            </div>

            {/* السوشيال ميديا */}
            <div className="card shadow-sm mb-4">
                <div className="card-body">
                    <h5 className="card-title mb-3">روابط التواصل الاجتماعي</h5>
                    <div className="mb-3">
                        <label className="form-label"><i className="fab fa-twitter text-info me-1"></i> Twitter</label>
                        <input type="url" className="form-control" dir="ltr" value={data.socialLinks.twitter}
                            onChange={e => setData(prev => ({ ...prev, socialLinks: { ...prev.socialLinks, twitter: e.target.value } }))} />
                    </div>
                    <div className="mb-3">
                        <label className="form-label"><i className="fab fa-facebook text-primary me-1"></i> Facebook</label>
                        <input type="url" className="form-control" dir="ltr" value={data.socialLinks.facebook}
                            onChange={e => setData(prev => ({ ...prev, socialLinks: { ...prev.socialLinks, facebook: e.target.value } }))} />
                    </div>
                    <div className="mb-3">
                        <label className="form-label"><i className="fab fa-whatsapp text-success me-1"></i> WhatsApp</label>
                        <input type="url" className="form-control" dir="ltr" value={data.socialLinks.whatsapp}
                            onChange={e => setData(prev => ({ ...prev, socialLinks: { ...prev.socialLinks, whatsapp: e.target.value } }))} />
                    </div>
                </div>
            </div>

            <div className="text-center">
                <button className="btn btn-primary px-4" onClick={handleSave} disabled={saving}>
                    {saving ? 'جاري الحفظ...' : 'حفظ جميع التغييرات'}
                </button>
            </div>
        </div>
    );
};

export default FooterEditor;
